import React from 'react';
import { Building2 } from 'lucide-react';

const SiteOfficeLoadingState = () => {
  return (
    <div
      className="fixed inset-0 bg-[#f8fafc] flex items-center justify-center relative overflow-hidden"
      style={{ fontFamily: "'Manrope', system-ui, sans-serif" }}
    >
      {/* Ambient background */}
      <div className="absolute inset-0" aria-hidden>
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-sky-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob"></div>
        <div className="absolute top-3/4 right-1/4 w-96 h-96 bg-sky-300 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-1/4 left-1/2 w-96 h-96 bg-slate-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-4000"></div>
      </div>

      <div className="relative z-10 flex flex-col items-center gap-4">
        <div className="relative w-20 h-20">
          <div className="absolute inset-0 rounded-full border-4 border-sky-100"></div>
          <div className="absolute inset-0 rounded-full border-4 border-t-[#0284c7] animate-spin"></div>
          <div className="absolute inset-2 bg-[#062a4a] rounded-full flex items-center justify-center">
            <Building2 className="w-7 h-7 text-[#38bdf8]" />
          </div>
        </div>
        <p className="text-sm font-medium text-slate-600">Memuat site office...</p>
      </div>
    </div>
  );
};

export default SiteOfficeLoadingState;
